import { useState, useEffect } from 'react';
import { publicApi } from '../api';

const useApi = (resource) => {
  const [data, setData]       = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    publicApi.get(resource)
      .then(setData)
      .finally(() => setLoading(false));
  }, [resource]);

  return { data, loading };
};

export default useApi;
